import { styled, Box, Button } from "@mui/material";

export const OptionGroupRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  boxSizing: "border-box",
  width: "max-content",
}));

export const OptionsList = styled(Box)(({ theme, length }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  padding: 0,
  flexWrap: "wrap",
  gap: "3.5rem 1rem",
}));

export const OptionButton = styled(Button)(
  ({ theme, active, plainStyle, cameras }) => ({
    zIndex: 3,
    position: "relative",
    padding: 0,
    pointerEvents: active ? "none" : "initial",
    cursor: !active ? "pointer" : "initial",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 55,
    minWidth: 55,
    height: 55,
    margin: "0 7px 0 0",
    transition: "all 0.3s ease-in-out",
    [theme.breakpoints.up("lg")]: {
      width: 70,
      height: 70,
      margin: "0 5px 0 0",
    },
    "&::before": {
      content: '""',
      display: "block",
      width: 61,
      height: 61,
      position: "absolute",
      top: -3,
      left: -3,
      border: `2px solid ${
        cameras
          ? theme?.palette?.companyColors?.neutral
          : theme?.palette?.companyColors?.secondary
      }`,
      borderRadius: theme?.borderRadius?.medium,
      opacity: active ? 1 : 0,
      transition: "all 0.3s ease-in-out",
      [theme.breakpoints.up("lg")]: {
        width: 72,
        height: 72,
        top: -1,
        left: -1,
        borderWidth: 3.5,
      },
    },
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: !plainStyle ? "cover" : "fill",
      objectPosition: "center",
      zIndex: 0,
      transition: "all 0.3s ease-in-out",
      borderRadius: theme?.borderRadius?.small,
      boxShadow: plainStyle ? "none" : "0px 0px 5px rgba(0,0,0,0.25)",
      [theme.breakpoints.up("lg")]: {
        width: "89%",
        height: "89%",
      },
    },
    "&:hover": {
      "&::before": {
        opacity: theme?.palette?.companyColors?.opacity50,
      },
    },
  })
);
